import { H1 } from 'components/typography/headings';
import {
    ProgressBarWellbeingStyles,
    ProgressBarLoader,
    ProgressBarTitleContainer,
} from './progress-bar-wellbeing.styles';
import { useLocation } from 'react-router';

export const ProgressBarWellbeing = () => {
    const location = useLocation();
    return (
        <>
            <ProgressBarTitleContainer>
                <H1 className={location.pathname.substring(1)}>Wellbeing</H1>
            </ProgressBarTitleContainer>
            <ProgressBarWellbeingStyles>
                <ProgressBarLoader>
                    <span className={location.pathname.substring(1)} />
                </ProgressBarLoader>
            </ProgressBarWellbeingStyles>
        </>
    );
};
